'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const StandardTileName = renderWithRef('StandardTileName', null, (a, o)=>jsx(RenderComp, {
        root: "div",
        forwardedRef: o,
        classNames: [
            'swan-standard-tile-name'
        ],
        props: a,
        children: a.children
    }));

export { StandardTileName };
